import type {BioIconProps} from '../../icons/common-types'
import {FlagIconsUS} from '../../icons/flag-icons-us'

export default function TopStatesReviewsLogo({...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.4"
          d="M11.5603 18.6665H5.33366C3.86699 18.6665 2.66699 19.8665 2.66699 21.3332V29.3332H11.5603V18.6665Z"
          fill="white"
        />
        <path
          d="M17.7735 13.3335H14.2135C12.7469 13.3335 11.5469 14.5335 11.5469 16.0002V29.3335H20.4402V16.0002C20.4402 14.5335 19.2535 13.3335 17.7735 13.3335Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M26.6671 22.6665H20.4404V29.3332H29.3338V25.3332C29.3338 23.8665 28.1338 22.6665 26.6671 22.6665Z"
          fill="white"
        />
        <path
          d="M20.0132 6.46649C20.4266 6.05316 20.5866 5.55983 20.4532 5.13316C20.3199 4.70649 19.9066 4.39983 19.3199 4.3065L18.0399 4.09316C17.9866 4.07983 17.8666 3.99981 17.8399 3.94647L17.1332 2.53314C16.5999 1.45314 15.3866 1.45314 14.8532 2.53314L14.1466 3.94647C14.1199 3.99981 13.9999 4.07983 13.9466 4.09316L12.6666 4.3065C12.0799 4.39983 11.6799 4.70649 11.5332 5.13316C11.3999 5.55983 11.5599 6.05316 11.9732 6.46649L12.9599 7.46649C12.9999 7.50649 13.0532 7.6665 13.0399 7.71983L12.7599 8.94648C12.5466 9.85314 12.8932 10.2665 13.1199 10.4398C13.3466 10.5998 13.8399 10.8132 14.6532 10.3332L15.8532 9.62649C15.9066 9.58649 16.0799 9.58649 16.1332 9.62649L17.3332 10.3332C17.7066 10.5598 18.0132 10.6265 18.2532 10.6265C18.5332 10.6265 18.7332 10.5198 18.8532 10.4398C19.0799 10.2798 19.4266 9.86648 19.2132 8.94648L18.9332 7.71983C18.9199 7.65316 18.9599 7.50649 19.0132 7.46649L20.0132 6.46649Z"
          fill="white"
        />
      </svg>
      <span>Top States Reviews</span>
      <FlagIconsUS className="absolute -right-6 -top-3 size-8 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5" />
    </div>
  )
}
